module.exports = __webpack_public_path__ + "bl.994df095535dbf7320f5.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/bl.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/bl.svg
// module chunks = styles